"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _defaultProps = _interopRequireDefault(require("./default-props"));
var _input = require("../input");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
const stateReducer = (type, nextState) => nextState;
class StatefulPinCodeContainer extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", this.props.initialState);
    _defineProperty(this, "handleChange", ({
      values,
      event
    }) => {
      this.props.onChange({
        values,
        event
      });
      const nextState = this.props.stateReducer(_input.STATE_CHANGE_TYPE.change, {
        values
      }, this.state);
      this.setState(nextState);
    });
  }
  render() {
    return this.props.children({
      ..._defaultProps.default,
      'aria-label': this.props['aria-label'],
      'aria-labelledby': this.props['aria-labelledby'],
      'aria-describedby': this.props['aria-describedby'],
      autoComplete: this.props.autoComplete,
      autoFocus: this.props.autoFocus,
      disabled: this.props.disabled,
      error: this.props.error,
      id: this.props.id,
      name: this.props.name,
      overrides: this.props.overrides,
      placeholder: this.props.placeholder,
      positive: this.props.positive,
      required: this.props.required,
      size: this.props.size,
      manageFocus: this.props.manageFocus,
      values: this.state.values,
      onChange: this.handleChange,
      mask: this.props.mask
    });
  }
}
exports.default = StatefulPinCodeContainer;
_defineProperty(StatefulPinCodeContainer, "defaultProps", {
  initialState: {
    values: _defaultProps.default.values
  },
  stateReducer,
  onChange: _defaultProps.default.onChange
});